import {CommonFileType} from '@toolify/server/src/services/FileTypeService/enum/CommonFileType'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'

export const UniqueFileIconMap = new Map([
  [CommonFileType.Other, {
    color: 'var(--content-dim-color)',
    iconNameType: IconNameType.File,
  }],
  [CommonFileType.Image, {
    color: '#00a9fb',
    iconNameType: IconNameType.FileImage,
  }],
  [CommonFileType.Audio, {
    color: '#c79700',
    iconNameType: IconNameType.FileAudio,
  }],
  [CommonFileType.Video, {
    color: '#00b8d7',
    iconNameType: IconNameType.FileVideo,
  }],
  [CommonFileType.Document, {
    color: '#92ac00',
    iconNameType: IconNameType.FilePdf,
  }],
  [CommonFileType.Sheet, {
    color: '#39ba63',
    iconNameType: IconNameType.FileSpreadsheet,
  }],
  [CommonFileType.Markdown, {
    color: '#0096e2',
    iconNameType: IconNameType.FileLines,
  }],
  [CommonFileType.Text, {
    color: '#6b7683',
    iconNameType: IconNameType.FileLines,
  }],
  [CommonFileType.Archive, {
    color: '#b07d2b',
    iconNameType: IconNameType.BoxesStacked,
  }],
  [CommonFileType.Html, {
    color: '#6783ec',
    iconNameType: IconNameType.FileCode,
  }],
])
